/* unplugin-vue-components disabled */import script from "./quickLinkList.vue?vue&type=script&lang=js"
export * from "./quickLinkList.vue?vue&type=script&lang=js"

import "./quickLinkList.vue?vue&type=style&index=0&id=760b0012&lang=scss"

const __exports__ = script;

export default __exports__